import { createAction, props } from "@ngrx/store";
import { ExchangeType } from "../models/exchange-type.model";
import { Exchange } from "../models/exchange.model";
import { User } from "../models/user.model";
import { WorkTray } from "../models/work-tray.model";
import { Customer } from "../models/customer.model";
import { Producer } from "../models/producer.model";
import { NotificationItem } from "../models/notification.model";
import { Person } from "../models/person.model";
import { Currency } from "../models/order-currency.model";
import { Role } from "../models/role.model";
import { CompanySettings } from "../models/settings/company-settings.model";
import { OrderCreateCurrencies } from "../models/order-create-currencies.model";
import { ExpenseReason } from "../models/expense/expense-reason";
import { KeyValue } from "@angular/common";
import { OrderTransactionTypes } from "../models/order-transaction-types.interface";

// Exchanges
export const loadAllExchanges = createAction(
  "[Monitor Resolver] Load all current exchanges"
);

export const allExchangesLoaded = createAction(
  "[Load Exchanges Effect] All exchanges loaded",
  props<{ exchanges: Exchange[] }>()
);

export const loadExchangeTypeReference = createAction(
  "[Add Exchange Modal] load exchange type reference"
);

export const loadRoleTypeReference = createAction(
  "[Shared Dispatcher] load role type reference"
);

export const loadRoleTypeReferenceLoaded = createAction(
  "[Shared Dispatcher] role type reference loaded",
  props<{ roles: Role[] }>()
);

export const loadTransactionTypeReference = createAction(
  "[Shared Dispatcher] load Transaction type reference"
);

export const reloadTransactionTypeReference = createAction(
  "[Shared Dispatcher] reload Transaction type reference"
);

export const loadTransactionTypeReferenceLoaded = createAction(
  "[Shared Dispatcher] Transaction type reference loaded",
  props<{ data: string[] }>()
);

export const exchangeTypeReferenceLoaded = createAction(
  "[Reference Service] exchange type reference loaded",
  props<{ exchangeTypes: ExchangeType[] }>()
);

export const loadOrderCurrencyReference = createAction(
  "[Reference Service] load currency order type reference"
);

export const orderCurrencyReferenceLoaded = createAction(
  "[Reference Service] order currency reference loaded",
  props<{ orderCurrencies: Currency[] }>()
);

export const loadOrderCreateCurrencyReference = createAction(
  "[Reference Service] load currency create order type reference"
);

export const forceLoadOrderCreateCurrencyReference = createAction(
  "[Reference Service] Force load currency create order type reference"
);

export const orderCreateCurrencyReferenceLoaded = createAction(
  "[Reference Service] order create currency reference loaded",
  props<{ orderCurrencies: OrderCreateCurrencies }>()
);

export const loadOrderTransactionTypesReference = createAction(
  "[Reference Service] load order transaction types reference"
);

export const OrderTransactionTypesReferenceLoaded = createAction(
  "[Reference Service] load order transaction types reference loaded",
  props<{ data: OrderTransactionTypes }>()
);

export const loadCustomerRolesReference = createAction(
  "[Reference Service] load Customer Roles reference"
);

export const loadCustomerRolesLoaded = createAction(
  "[Reference Service] Customer roles reference loaded",
  props<{ roles: Role[] }>()
);

export const loadProducerRolesReference = createAction(
  "[Reference Service] load Producer Roles reference"
);

export const loadProducerRolesLoaded = createAction(
  "[Reference Service] Producer roles reference loaded",
  props<{ roles: Role[] }>()
);

// Users
export const searchUsers = createAction("[User Component] search users");

export const addFilterUsers = createAction(
  "[User Component] Adds the user filter",
  props<{ filters?: string }>()
);

export const allUsersLoaded = createAction(
  "[User Effects] All users loaded",
  props<{ users: User[] }>()
);

export const addFilterUCustomers = createAction(
  "[Customer Component] Adds the customer filter",
  props<{ filters?: string }>()
);

export const allCustomersLoaded = createAction(
  "[Customer Effects] All customers loaded",
  props<{ customers: Customer[] }>()
);

export const addFilterUProducers = createAction(
  "[Producer Component] Adds the producer filter",
  props<{ filters?: string }>()
);

export const allProducersLoaded = createAction(
  "[Producer Effects] All producers loaded",
  props<{ producers: Producer[] }>()
);

// WorkTray reference
export const loadworkTrayReference = createAction(
  "[Orders component] Load work tray reference"
);

export const workTrayReferenceLoaded = createAction(
  "[Reference Service] Work tray reference laoded",
  props<{ workTrays: WorkTray[] }>()
);

export const resetWorkTrayReference = createAction(
  "[Log out] Reset work tray reference"
);

// Help Tour
export const startHelpTour = createAction(
  "[Menu Component] Start help tour",
  props<{ component: string }>()
);

export const finishHelpTour = createAction("[Menu Component] Finish help tour");

export const setworkInProgressFlag = createAction(
  "[Auth component] Set Use Help flag",
  props<{ workInProgress: boolean }>()
);


// Notifications
export const loadNotifications = createAction("[Menu component] Get user notification");

export const notificationLoaded = createAction("[Menu component] Notification loaded",
  props<{ notifications: NotificationItem[] }>());

export const deleteNotification = createAction(
  "[Menu component] Delete one notification",
  props<{ id: string }>()
);

export const notificationDeleted = createAction("[Side Effect] Notification deleted");

// Customers
export const loadCustomers = createAction(
  "[Shared Action] Load customers"
)

export const loadCustomersSuccess = createAction(
  "[Shared Effect] Load customers Finished Successfully",
  props<{ customers: Customer[] }>()
)

export const loadCustomersFailure = createAction(
  "[Shared Effect] Load customers Finished with Errors",
  props<{ error: any }>()
)

export const forceLoadCustomers = createAction(
  "[Shared Action] Force Load customers"
)

// Products
export const loadProducers = createAction(
  "[Shared Action] Load producers"
)

export const loadProducersSuccess = createAction(
  "[Shared Effect] Load producers Finished Successfully",
  props<{ producers: Producer[] }>()
)

export const loadProducersFailure = createAction(
  "[Shared Effect] Load producers Finished with Errors",
  props<{ error: any }>()
)

export const forceLoadProducers = createAction(
  "[Shared Action] Force Load producers"
)

// Suppliers
export const loadSuppliers = createAction(
  "[Shared Action] Load suppliers"
)

export const loadSuppliersSuccess = createAction(
  "[Shared Effect] Load suppliers Finished Successfully",
  props<{ suppliers: Person[] }>()
)

// Account Currencies
export const loadAccountCurrenciesReference = createAction(
  "[Shared Dispatcher] load Account Currencies reference"
);

export const reloadAccountCurrenciesReference = createAction(
  "[Shared Dispatcher] reload Account Currencies reference"
);

export const loadAccountCurrenciesReferenceLoaded = createAction(
  "[Shared Dispatcher] Account Currencies reference loaded",
  props<{ data: string[] }>()
);

// Company Account Currencies
export const loadCompanyAccountCurrenciesReference = createAction(
  "[Shared Dispatcher] load Company Account Currencies reference"
);

export const reloadCompanyAccountCurrenciesReference = createAction(
  "[Shared Dispatcher] reload Company Account Currencies reference"
);

export const loadCompanyAccountCurrenciesReferenceLoaded = createAction(
  "[Shared Dispatcher] Company Account Currencies reference loaded",
  props<{ data: string[] }>()
);

export const loadCompanySettings = createAction(
  "[Shared Dispatcher] Get Company Settings"
);

export const loadCompanySettingsLoaded = createAction(
  "[Shared Dispatcher] Get Company Settings loaded",
  props<{ data: CompanySettings }>()
);


export const clearCompanySettings = createAction(
  "[Shared Dispatcher] Remove Company Settings"
);

// Expenses

export const loadExpensesCurrenciesReference = createAction(
  "[Shared Dispatcher] load Expenses Currencies reference"
);

export const loadReasons = createAction(
  "[Shared Action] Load reasons"
)

export const loadReasonsSuccess = createAction(
  "[Shared Effect] Load reasons Finished Successfully",
  props<{ expenseReasons: ExpenseReason[] }>()
)

export const loadReasonsFailure = createAction(
  "[Shared Effect] Load reasons Finished with Errors",
  props<{ error: any }>()
)

// CompanyVirtualAccount
export const loadCompanyVirtualAccount = createAction(
  "[Shared Action] Load company virtual accounts"
)

export const reloadCompanyVirtualAccount = createAction(
  "[Shared Action] Reload company virtual accounts"
)

export const loadCompanyVirtualAccountSuccess = createAction(
  "[Shared Effect] Load company virtual accounts Finished Successfully",
  props<{ accounts: KeyValue<string, string>[] }>()
)
